import { ref, isRef, Ref } from 'vue'
import { useQuery } from '@cqrs/vue-composables-cqrs'
import * as q from './queries-core'
export function useProjectPlanTemplatesPageQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		...useQuery(() => new q.ProjectPlanTemplatesPageQueryV1(_workspaceId.value, _strategyId.value))
	}
	return {
		...result,
		runProjectPlanTemplatesPageQueryV1: result.run,
		modelProjectPlanTemplatesPageQueryV1: result.model,
	}
}

